import { getNestedValue } from '@/utils/object'
import { formatDatetime } from '@/utils/dates.js'
import { getFormattedAddress } from '@/utils/address'
import { secondsToDuration } from '@/utils/dates.js'

/**
 * Used by Diagnostics module to display analysis overview (After search validation)
 *
 * @API APIV2_HISTORIQUE_BY_VEHICLE_DATES
 * @param {*} item
 * @param {*} options
 */
export default function normalizeTripHistoryItem(item, options = {}) {
  let r = {
    //vehicleId: getNestedValue(item, 'vehicule_id'),
    vehicleName: getNestedValue(item, 'vehicule_nom'),
    vehicleRegistrationPlate: getNestedValue(item, 'vehicule_immatriculation'),
    startDateFormatted: getNestedValue(item, 'dh_activ_deb', '', {
      transform: (rawValue) =>
        formatDatetime(rawValue, {
          useFrenchTimeSeparator: true,
        }),
    }),
    startAddress: getFormattedAddress(item, {
      streetAddress: 'adresse_deb',
      zipCode: 'cp_deb',
      city: 'ville_deb',
    }),
    endDateFormatted: getNestedValue(item, 'dh_activ_fin', '', {
      transform: (rawValue) =>
        formatDatetime(rawValue, {
          useFrenchTimeSeparator: true,
        }),
    }),
    endAddress: getFormattedAddress(item, {
      streetAddress: 'adresse_fin',
      zipCode: 'cp_fin',
      city: 'ville_fin',
    }),
    durationFormatted: getNestedValue(item, 'duree_troncon', '', {
      transform: (rawValue) => secondsToDuration(rawValue),
    }),
    distanceKmFormatted: getNestedValue(item, 'distance_troncon', '', {
      transform: (rawValue) => `${(rawValue || 0).toFixed(2)} km`,
    }),
    averageSpeedKmhFormatted: getNestedValue(item, 'vitesse', '', {
      transform: (rawValue) => `${rawValue} km/h`,
    }),
  }
  return r
}

/*
{
    "vehicule_id": 18954,
    "vehicule_nom": "104081",
    "vehicule_immatriculation": "",
    "categorie_nom": "LaFarge",
    "serveur_id": 74,
    "boitier_id": 38,
    "dh_vehicule_deb": "2021-12-16 00:00:00",
    "dh_vehicule_fin": "2021-12-16 23:59:59",
    "dh_activ_deb": "2021-12-16 06:21:33",
    "dh_activ_fin": "2021-12-16 17:21:13",
    "hdeb_activite": "00:00:00",
    "hfin_activite": "23:59:59",
    "latitude_deb": 43.9325,
    "longitude_deb": 4.78275,
    "latitude_mapmatch_deb": 43.9326,
    "longitude_mapmatch_deb": 4.78296,
    "adresse_deb": "Rocade Charles de Gaulle",
    "cp_deb": "84000",
    "ville_deb": "Avignon",
    "latitude_fin": 43.9327,
    "longitude_fin": 4.78172,
    "latitude_mapmatch_fin": 43.9326,
    "longitude_mapmatch_fin": 4.78104,
    "adresse_fin": "Rue du Grand Gigognan",
    "cp_fin": "84000",
    "ville_fin": "Avignon",
    "km_deb": null,
    "km_fin": null,
    "duree_troncon": 27317,
    "distance_troncon": 337.42,
    "nb_troncon": 24,
    "duree_arret": 11421,
    "distance_arret": 0.97,
    "nb_arret": 23,
    "vitesse": 44,
    "vitesse_max": 86,
    "duree_contact": 39360,
    "positions_nb": 5246,
    "couleur": "#EF5350",
    "executions_circuits": [],
    "linestring": "4.78275 43.932544444444,4.7827416666667 43.932516666667, ...."
}
*/
